import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import {
  useFilters, useModals, useSetState,
} from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import ManageSavedArtworkModal from '@modals/ManageSavedArtworkModal'
import ManageSavedArtworkPageModal from '@modals/ManageSavedArtworkPageModal'

import { SavedArtworkModel, SavedArtworkPageModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showManageSavedArtworkPageModal: false,
  showManageSavedArtworkModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManageSavedArtworkModal: {
      closeModal: () => setState({ showManageSavedArtworkModal: false }),
      deleteSavedArtwork: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateSavedArtwork: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    ManageSavedArtworkPageModal: {
      closeModal: () => setState({ showManageSavedArtworkPageModal: false }),
      deleteSavedArtworkPage: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateSavedArtworkPage: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }
  return componentCallbacks[component] || {}
}
const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showManageSavedArtworkModal, showManageSavedArtworkPageModal } = state

  const {
    callbacks: filterCallbacks,
    pageFilters,
  } = useFilters({ persistFilters: true })

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showManageSavedArtworkModal: (payload: { savedArtwork: SavedArtworkModel }) => {
        setModalData('ManageSavedArtworkModal', payload)
        setState({ showManageSavedArtworkModal: true })
      },
      showManageSavedArtworkPageModal: (payload: { savedArtworkPage: SavedArtworkPageModel }) => {
        setModalData('ManageSavedArtworkPageModal', payload)
        setState({ showManageSavedArtworkPageModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <ManageSavedArtworkPageModal
          // @ts-expect-error TS2322
          callbacks={callbacks('ManageSavedArtworkPageModal', setState)}
          showModal={showManageSavedArtworkPageModal}
        />

        <ManageSavedArtworkModal
          // @ts-expect-error TS2322
          callbacks={callbacks('ManageSavedArtworkModal', setState)}
          showModal={showManageSavedArtworkModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
